/*
* Bootstrap Modal Mods
*/

var modalDebounce;

function modalShowHandler () {
  const $this = jQuery(this);
  $this.attr('aria-hidden', 'false');
  $this.css('display', 'block');
  var dialogBox = $this.find('.modal-dialog');
  var offset = (jQuery(window).height() - dialogBox.height()) / 2;
  var bottomMargin = parseInt(dialogBox.css('marginBottom'), 10);
  if (offset < bottomMargin) {
    offset = bottomMargin;
  }
  if (window.outerWidth >= window.breakpoints.md) {
    dialogBox.css('margin-top', offset);
  }
  if (modalDebounce) {
    clearTimeout(modalDebounce);
  }
  modalDebounce = setTimeout(function () {
    jQuery('.modal.in').find('input').filter(':visible').first().focus();
  }, 200);
  $this.attr('aria-hidden', 'false');
}

function modalHideHandler () {
  jQuery(this).attr('aria-hidden', 'true');
}

export function modalbox () {
  jQuery(document).on('show.bs.modal', '.modal', modalShowHandler);
  jQuery(document).on('hide.bs.modal', '.modal', modalHideHandler);
  jQuery(window).on('resize', function () {
    jQuery('.modal:visible').each(modalShowHandler);
  });
}
